import { ReactComponent as IconTrashBin } from "@/assets/svgs/delete.svg";
import useEForm from "@/hooks/use-eform/index.js";
import { Fragment } from "react";
import Button from "../Button/index.js";
import EFormFieldComponent from "./FormField/index.jsx";

const EFormComponent = ({
	fieldId = '',
	schema,
	required,
	payload,
	setPayload,
	isDirty,
	isReadOnly,
	setIsValidFormat,
	parentProps = [],
	errorListToDisplay,
	isSubmitClicked = false,
}) => {
	const { getFieldValue, getFullJson, getNextPayload } = useEForm();

	function onAddItemBtnClicked(parentProps, fieldSchema) {
		const arr = [
			...getFieldValue(payload, parentProps),
			getFullJson(fieldSchema)[0],
		];
		const nextPayload = getNextPayload(payload, parentProps, arr);
		setPayload(nextPayload);
	}

	function onRemoveItemBtnClicked(parentProps, index) {
		const arr = getFieldValue(payload, parentProps).filter(
			(_, i) => i !== index
		);
		const nextPayload = getNextPayload(payload, parentProps, arr);
		setPayload(nextPayload);
	}

	if (!payload || !schema) {
		return;
	}

	const currentPayload = getFieldValue(payload, parentProps);

	const schemaType = schema["x-uitype"] ?? schema.type;
	const currentType = Array.isArray(schemaType)
		? schemaType.find((d) => d !== "null")
		: schemaType;

	switch (currentType) {
		case "object":
			return (
				<>
					{Object.keys(currentPayload).map((key, index) => {
						if (key === "attachments") {
							return <></>;
						}

						return (
							<EFormComponent
								key={key}
								fieldId={key}
								isReadOnly={isReadOnly}
								schema={schema.properties[key]}
								required={schema.required}
								payload={payload}
								setPayload={setPayload}
								isDirty={isDirty}
								setIsValidFormat={setIsValidFormat}
								parentProps={[...parentProps, key]}
								errorListToDisplay={errorListToDisplay}
								isSubmitClicked={isSubmitClicked}
							/>
						);
					})}
				</>
			);

		case "array":
			const propertyName = parentProps[parentProps.length - 1];
			return (
				<div className="eform-array-panel" data-testid="eform-array-panel">
					<div className="eform-array-panel-title">
						{!!required?.includes(propertyName) && (
							<span className="eform-label-asterisk" data-testid="eform-array-label-asterisk">*</span>
						)}
						<span data-testid="eform-array-label">{schema.description}</span>
					</div>
					{currentPayload.map((_, arrIdx) => (
						<Fragment key={`${schema.description}_${arrIdx}`}>
							<div className="eform-array-top-banner mb-1 flex-box flex-align-center flex-space-between font-size-m font-weight-bold">
								{`Item #${arrIdx + 1}`}

								{!isReadOnly && currentPayload.length > 1 && (
									<div className="flex-box flex-align-center">
										<IconTrashBin
											data-testid="eform-array-delete-btn"
											className="eform-array-delete-btn"
											onClick={(e) => {
												e.preventDefault();
												onRemoveItemBtnClicked(
													parentProps,
													arrIdx
												);
											}}
										/>
									</div>
								)}
							</div>

							<div className="eform-form mb-2">
								<EFormComponent
									fieldId={fieldId}
									isReadOnly={isReadOnly}
									schema={schema.items}
									required={schema.required}
									payload={payload}
									setPayload={setPayload}
									isDirty={isDirty}
									setIsValidFormat={setIsValidFormat}
									parentProps={[...parentProps, arrIdx]}
									errorListToDisplay={errorListToDisplay}
									isSubmitClicked={isSubmitClicked}
								/>
							</div>
						</Fragment>
					))}

					{!isReadOnly && (
						<div className="flex-box flex-align-center mb-2">
							<Button
								data-testid="eform-array-add-btn"
								text={"Add +"}
								sizing="Medium"
								full
								maxWidth="154"
								type="button"
								submit={(e) => {
									e.preventDefault();
									onAddItemBtnClicked(parentProps, schema);
								}}
							/>
						</div>
					)}
				</div>
			);

		default:
			return (
				<EFormFieldComponent
					fieldId={fieldId}
					isReadOnly={isReadOnly}
					schema={schema}
					payload={payload}
					required={required}
					setPayload={setPayload}
					isDirty={isDirty}
					setIsValidFormat={setIsValidFormat}
					parentProps={parentProps}
					errorListToDisplay={errorListToDisplay}
					isSubmitClicked={isSubmitClicked}
				/>
			);
	}
};

export default EFormComponent;
